import { gql } from "@apollo/client";

export const UNASSIGN_STUDENT_MUTATION = gql(/* GraphQL */ `
  mutation UnassignPersonStudents($personId: UUID!, $studentIds: [UUID!]!) {
    unassignPersonStudents(
      input: { personId: $personId, studentIds: $studentIds }
    ) {
      __typename
      person {
        id
        students {
          pageInfo {
            startCursor
            endCursor
            hasNextPage
            hasPreviousPage
          }
          edges {
            cursor
            node {
              id
              firstName
              lastName
              dob
              createdAt
              sessions {
                id
                createdAt
                finishedAt
              }
              lastSession {
                finishedAt
              }
            }
          }
          totalCount
        }
      }
      errors {
        __typename
          ... on ValidationError {
            message
            errors {
              fieldName
              messages
            }
          }
      }
    }
  }
`);
